/*
 * @Description: 
 * @Version: 1.0
 * @Autor: zhangle
 * @Date: 2022-05-30 09:38:53
 * @LastEditors: zhangle
 * @LastEditTime: 2023-02-13 14:00:30
 */
import {Toast, MessageBox} from 'mint-ui';
import router from '../router/index'
// 0 未认证 （ 未认证 ） 1 个人认证（ 已认证 ） 2 正常企业认证待审核( 基础信息审核中 ) 3 企业已认证需要完善信息（ 已认证待完善 ） 4 完善信息待审核( 认证信息审核中 ) 5 正常企业认证被拒绝（ 基础信息已拒绝 ） 6 完善信息审核被拒绝（ 认证信息已拒绝 ） 7 企业认证成功（ 已认证 ） 8 个人已认证需要完善信息（ 已认证待完善 ）


export const userStatusObj = {
    '0': {
        clientName: '未认证',
        serverName: '未认证',
        message: '',
        callback: () => {
            MessageBox.confirm('', { 
                 message: '您还未通过实名认证，请先通过实名认证！', 
                 title: '提示', 
                 confirmButtonText: '去认证', 
                 cancelButtonText: '取消' 
            }).then(action => { 
                if (action == 'confirm') {
                    router.push({
                        path: '/realName',
                    })
                }
            }).catch(err => { 
                
            });
        }
    },
    '1': {
        clientName: '已认证',
        serverName: '个人认证',
        message: '',
        callback: () => {
            
        }
    },
    '2': {
        clientName: '基础信息审核中',
        serverName: '正常企业认证待审核',
        message: '',
        callback: () => {
            // Toast("您已提交认证，请耐心等待审核结果");
            router.push({
                path: '/realName',
                query: {
                  type: 'ENTERPRISE'
                }
            })
        }
    },
    '3': {
        clientName: '已认证待完善',
        serverName: '企业已认证需要完善信息',
        message: '',
        callback: () => {
            router.push({
                path: '/realName',
                query: {
                  type: 'ENTERPRISE'
                }
            })
        }
    },
    '4': {
        clientName: '认证信息审核中',
        serverName: '完善信息待审核',
        message: '',
        callback: () => {
            router.push({
                path: '/realName',
                query: {
                  type: 'ENTERPRISE'
                }
            })
        }
    },
    '5': {
        clientName: '基础信息已拒绝',
        serverName: '正常企业认证被拒绝',
        message: '',
        callback: () => {
            router.push({
                path: '/realName',
                query: {
                  type: 'ENTERPRISE'
                }
            })
        }
    },
    '6': {
        clientName: '认证信息已拒绝',
        serverName: '完善信息审核被拒绝（企业）',
        message: '',
        callback: () => {
            router.push({
                path: '/realName',
                query: {
                  type: 'ENTERPRISE'
                }
            })
        }
    },
    '7': {
        clientName: '已认证',
        serverName: '企业认证成功',
        message: '',
        callback: () => {
            
        }
    },
    '8': {
        clientName: '已认证待完善',
        serverName: '个人已认证需要完善信息',
        message: '',
        callback: () => {
            router.push({
                path: '/realName',
                query: {
                  type: 'PERSON',
                  identifyType: '1'
                }
            })
        }
    }

}
export const userStatus = (status, customArray, callback) => {
    return new Promise((resolve) => {
        // console.log(Object.keys(userStatusObj))
        if (Object.keys(userStatusObj).indexOf(status) > -1) { // 如果状态码在 userStatusObj 的范围内
            if (callback && typeof callback === 'function') {
                if (customArray.indexOf(status) > -1) { // 需要在外部处理的状态码
                    callback()
                } else {
                    userStatusObj[status].callback()
                }
            } else {
                userStatusObj[status].callback()
            }
            if (status === '1' || status === '7') {
                resolve({
                    statusCode: true // 如果认证成功返回true， 其余都是false
                })
            } else {
                resolve({
                    statusCode: false // 如果认证成功返回true， 其余都是false
                })
            }
        } else {
            resolve({
                statusCode: false
            })
        }
    })
}


// WEBPACK FOOTER //
// ./src/config/userStatus.js